import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import { UpdatePasswordDialogValues } from 'src/models/UpdatePasswordDialog.model';
import ATMPassword from 'src/components/UI/atoms/formFields/ATMPassword/ATMPassword';

type Props = {
  formikProps: FormikProps<UpdatePasswordDialogValues>;
  onClose: () => void;
};

const ChangeTrainerPassword = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'> Change  Password</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
        <div>
          <ATMPassword
            name='newPassword'
            value={values?.newPassword}
            onChange={(e) => {
              setFieldValue('newPassword', e.target.value);
            }}
            label='New Password'
            placeholder='New Password'
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMPassword
            name='confrimPassword'
            value={values?.confrimPassword}
            onChange={(e) => {
              setFieldValue('confrimPassword', e.target.value);
            }}
            label='Confrim Password'
            placeholder='Confrim Password'
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ChangeTrainerPassword;